import type { ReactNode } from 'react';
import styles from './Card.module.css';

interface CardProps {
  children: ReactNode;
  className?: string;
}

export function Card({ children, className = '' }: CardProps) {
  return <section className={`${styles.card} ${className}`.trim()}>{children}</section>;
}

export function CardHeader({ children, className = '' }: CardProps) {
  return <div className={`${styles['card-header']} ${className}`.trim()}>{children}</div>;
}

export function CardBody({ children, className = '' }: CardProps) {
  return <div className={`${styles['card-body']} ${className}`.trim()}>{children}</div>;
}
